import type { QueryFnParams } from '@libs/data-access/queries'
import { httpServices } from '@libs/data-access/queries'

export type FetchPlannableStatsOptions = QueryFnParams<{
  queryParams: {
    starts_at: string
    ends_at: string
    user_contract_ids: number[]
  }
}>

export const fetchPlannableStats = async (opts: FetchPlannableStatsOptions) => {
  const { data } = await httpServices.core.get(`/stats/plannable_count`, {
    params: opts?.queryParams
  })

  return data
}
